export const GET_ACCESSORIALS = 'GET_ACCESSORIALS';
